import axios from "axios";

/**
 * Fetch Express data from pathToPurchaseLink
 * @param {string} purchaseLink - The purchase link URL
 * @param {string} canaryVersion - The canary version for X-Canary header
 * @returns {Promise<Object>} Express data
 */
export const fetchExpressData = async (purchaseLink, canaryVersion) => {
  const response = await axios.get(purchaseLink, {
    headers: {
      "X-Canary": canaryVersion,
    },
  });

  return response.data;
};
